import React from "react";

const ContactFrom = () => {
  return (
    <>
      <section className="rs-contact-form-area rs-contact-seven">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div className="rs-contact-form">
                <h3 className="rs-contact-form-title">Get in Touch</h3>
                <p className="descrip">
                  The point of using Lorem Ipsum is that it has more-or-less
                  packages normal make a type specimen book it has survived
                </p>
                <form id="contact-form">
                  <div className="row g-5">
                    <div className="col-md-4">
                      <div className="rs-contact-input">
                        <input
                          id="name"
                          name="name"
                          type="text"
                          placeholder="Full Name"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="rs-contact-input">
                        <input
                          id="email"
                          name="email"
                          type="email"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="rs-contact-input">
                        <input
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder="Phone Number"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="rs-contact-input">
                        <input
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder="Address"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="rs-contact-input">
                        <input
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder="Subject"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="rs-contact-input">
                        <textarea
                          id="message"
                          name="message"
                          placeholder="Write Your Message"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="rs-contact-btn">
                        <button
                          type="submit"
                          className="rs-btn has-theme-orange"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div id="form-messages"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="rs-map-area rs-map-one">
        <div className="rs-google-map">
          <iframe
            title="Eque Spinning & Composite Industries Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3590.2591803752007!2d88.862193!3d25.8609458!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e359606d858d99%3A0xb47d94c458fe4da3!2sEque%20Spinning%20%26%20Composite%20Industries!5e0!3m2!1sen!2sbd!4v1786941724857!5m2!1sen!2sbd"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default ContactFrom;
